module.exports = __webpack_public_path__ + "static/img/img4.55458d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img4.png
// module id = MKzk
// module chunks = 1